import { Link } from 'react-router';

import { Card } from '@cfa/react-components';

import { useSearchClickFeedback } from '../hooks';

import { AnswerSource } from '@/_generated/api-clients/xp';
import SearchResultCardImage from '@/routes/SearchResults/components/SearchResultCardImage';

interface SmartSourceCardProps {
  source: AnswerSource;
}

const SmartSourceCard: React.FC<SmartSourceCardProps> = ({ source }) => {
  const sendClickFeedback = useSearchClickFeedback();

  return (
    <Link
      to={`/doc/${source.documentId}`}
      target="_blank"
      onClick={() => sendClickFeedback(source)}
    >
      <Card
        elevation={1}
        id={`a${source.documentId}`}
        title={source.name}
        variant="default"
        className="animate-fade-in! border-grayscale-gray2! flex! cursor-pointer! flex-row! items-center! border! p-4!"
      >
        <SearchResultCardImage
          documentType=""
          icon={source.icon ?? undefined}
          name={source.name}
        />
        <div className="w-full">
          <div className="flex flex-row items-center">
            <p className="text-variant-body1 text-brand-navy pb-0!">
              {source.name}
            </p>
          </div>
        </div>
      </Card>
    </Link>
  );
};

export default SmartSourceCard;
